<template>
  <div class="portal-ad">
    <el-header class="decision-management-header" height="32px">
      <div class="decision-management-header-wrap">
        <span>决策中心>菜单管理</span>
      </div>
    </el-header>
    <div class="decision-management-top-search">
      <sw-button
        type="primary"
        size="small"
        @click="$router.push({ path: 'addDecisionColumn' })"
      >
        <sw-icon icon="add" />添加
      </sw-button>
      <sw-button
        plain
        size="small"
        @click="deleteColumn"
        :disabled="this.tableSelect.length > 0 ? false : true"
      >
        <sw-icon icon="trash" />删除
      </sw-button>
      <div style="flex: 1"></div>
      <sw-search
        :placeholder="'栏目名称'"
        @search="searchHandle"
        v-model="searchColumn"
      ></sw-search>
    </div>
    <div class="portalCms-column-content">
      <!-- <sw-table
        v-if="showList"
        :tableName="'sw-table-example-8'"
        :tableData="tableData"
        :tableTitle="tableTitle"
        :tableOperation="tableOperation"
        row-key="index"
        default-expand-all
        @selection-change="selectionChange"
        @operation-handle="operationHandle"
      >
      </sw-table> -->

      <sw-table
        v-if="showList"
        :tableName="'sw-table-example-8'"
        :tableData="tableData"
        :tableTitle="tableTitle"
        :tableOperation="tableOperation"
        row-key="id"
        default-expand-all
        @selection-change="selectionChange"
        @operation-handle="operationHandle"
      ></sw-table>
    </div>
  </div>
</template>

<script>
import { getColumnList, deleteColumnList } from "@/api/cms-api";
import { getMenuList, deleteMenuById } from "@/api/shangcai.js";
export default {
  name: "decisionManagement",
  data() {
    return {
      rootId: "000",
      tableData: [],
      tableLength: 0,
      showList: false,
      height: "530px",
      tableTitle: [
        {
          prop: "menuName",
          label: "菜单名称",
          width: "120",
          sortable: false,
        },
        {
          prop: "menuIcon",
          label: "菜单图标",
          width: "120",
          sortable: false,
        },
        {
          prop: "contentUrl",
          label: "菜单链接",
          width: "120",
          sortable: false,
        },
        {
          prop: "menuCode",
          label: "菜单代码",
          width: "120",
          sortable: false,
        },
        {
          prop: "sortNum",
          label: "排列序号",
          width: "120",
          sortable: false,
        },
        {
          prop: "menuDescription",
          label: "菜单描述",
          width: "120",
          sortable: false,
        },
      ],
      tableOperation: [
        // {
        //   name: "添加子栏目",
        //   icon: "su-icon-department",
        //   operation: "addChild",
        // },
        {
          name: "编辑",
          icon: "su-icon-edit",
          operation: "edit",
          className: "testgreen",
        },
        { name: "删除", icon: "su-icon-delete", operation: "delete" },
      ],
      tableSelect: [],
      searchColumn: "",
      total: 1,
    };
  },
  created() {
    this.handleColumnList();
    console.log("测试是否有缓存，是否打印值1111");
  },
  mounted() {},
  methods: {
    mvColumnSet(columnId, pColumnId) {
      let data = {
        columnId,
        pColumnId,
      };
      mvColumn(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("排序成功");
        }
      });
    },
    handleOrder(data) {
      console.log("data", data);
      let arr = [];
      let arr1 = [];
      data[0].children.forEach((item) => {
        arr.push(item.id);
        item.children.forEach((item1) => {
          arr1.push(item1.id);
        });
      });

      let str = arr.join(",");
      let str1 = arr1.join(",");
      console.log("str", str);
      console.log("str1", str1);
      this.mvColumnSet(str1, str);
    },
    // operationHandle(rowObj, operation) {
    //   console.log(rowObj, operation);
    //   this.$confirm(JSON.stringify(rowObj) + "," + operation);
    // },
    buildTree(list) {
      var map = {},
        tree = [];
      list.forEach((item) => {
        map[item.id] = item;
        item.children = [];
      });
      list.forEach((item) => {
        item.index = item.id;
        if (item.pId !== "-1") {
          if (!map[item.pId]) {
            tree.push(item);
            return;
          }
          map[item.pId].children.push(item);
        } else {
          tree.push(item);
        }
      });
      return tree;
    },
    handleColumnList() {
      let data = {
        columnName: this.searchColumn,
        id: "000",
      };
      getMenuList().then((res) => {
        // debugger;
        this.showList = true;
        let data = res.data.list[0].children || [];
        this.tableLength = data.length;
        // this.tableData = this.buildTree(data);
        // console.log(this.tableData)
        this.tableData = data;
      });
    },
    //拖拽
    // searchHandle(val) {
    //   this.searchColumn = val;
    //   this.handleColumnList();
    // },
    searchHandle() {
      this.handleColumnList();
    },
    selectionChange(data) {
      this.tableSelect = data;
    },
    deleteColumn() {
      // if (this.tableSelect && this.tableSelect.length === 0) {
      //   this.$message.error("请选择要操作的数据！");
      //   return false;
      // }
      let id = [];
      this.tableSelect.forEach((item) => {
        id.push(item.id);
      });
      if (id.indexOf(this.rootId) >= 0) {
        this.$message.error("不可删除根目录，请重新选择！");
        return false;
      }
      let data = {
        id: id,
      };
      this.confirmDialoag("确认删除栏目吗？", () => this.deleteMenuById(data));
    },
    operationHandle(id, operation) {
      if (this[`${operation}Handle`]) {
        this[`${operation}Handle`](id);
      }
    },
    // deleteHandle(row) {
    //   if (row.id === this.rootId) {
    //     this.$message.error("不可删除根目录！");
    //     return false;
    //   }
    //   const data = {
    //     ids: [row.id],
    //   };
    //   this.confirmDialoag("确认删除栏目吗？", () =>
    //     this.deleteColumnList(data)
    //   );
    // },
    deleteHandle(row) {
      // if (row === this.rootId) {
      //   this.$message.error("不可删除根目录！");
      //   return false;
      // }
      const data = {
        id: [row],
      };
      this.confirmDialoag("确认删除栏目吗？", () => this.deleteMenuById(data));
    },
    deleteMenuById(data) {
      deleteMenuById(data).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: "删除成功～",
            type: "success",
          });
          this.handleColumnList();
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    //添加子栏目
    // addChildHandle(value) {
    //   this.$router.push({
    //     path: "/Columnv2/AddColumnv2",
    //     query: { columnId: value.id },
    //   });
    // },
    // addChildHandle(value) {
    //   this.$router.push({
    //     path: "/Columnv2/AddColumnv2",
    //     query: { columnId: value },
    //   });
    // },
    //拖拽
    // editHandle(value) {
    //   console.log("value", value);
    //   if (value.id === this.rootId) {
    //     this.$message.error("不可编辑根目录！");
    //     return false;
    //   }
    //   this.$router.push({
    //     path: "/Columnv2/AddColumnv2",
    //     query: { colId: value.id },
    //   });
    // },
    editHandle(value) {
      if (value === this.rootId) {
        this.$message.error("不可编辑根目录！");
        return false;
      }
      this.$router.push({
        path: "addDecisionColumn",
        query: { colId: value },
      });
    },
    confirmDialoag(confirmText, confirmFn, cancelFn) {
      this.$confirm(confirmText)
        .then(() => {
          confirmFn && confirmFn();
        })
        .catch(() => {
          cancelFn && cancelFn();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.portal-ad {
  height: calc(100vh - 100px);
  margin-left: 50px;

  .decision-management-header {
    background: #f4f8fc;
    box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
    span {
      font-size: 12px;
      line-height: 32px;
      padding: 0 2px;
    }
    &-wrap {
      span {
        padding-left: 7px;
        border-left: 3px solid #3394e1;
        color: rgba(2, 21, 37, 0.45);
      }
    }
  }
  .decision-management-top-search {
    height: auto;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .sw-button {
      font-size: 14px;
      margin: 0 8px 0 0;
    }
    .el-row {
      width: 320px;
    }
  }
}
</style>